module.exports = __webpack_public_path__ + "img/greece0.1ef0b532.jpg";